export const ARQUIVO_DOWNLOAD = 'ARQUIVO_DOWNLOAD';
export const ARQUIVO_DOWNLOAD_START = 'ARQUIVO_DOWNLOAD_START';
export const ARQUIVO_DOWNLOAD_SUCCESS = 'ARQUIVO_DOWNLOAD_SUCCESS';
export const ARQUIVO_DOWNLOAD_ERROR = 'ARQUIVO_DOWNLOAD_ERROR';
